var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"alert",attrs:{"type":_vm.alertType},on:{"click":function($event){return _vm.$emit('dismissAlert')}}},[_vm._v("\n  "+_vm._s(_vm.alertContent)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }